import LoggerProvider from "../../../providers/LoggerProvider";
import HelloRetailClient from "./HelloRetailClient";
import HelloRetailDataMapper from "./HelloRetailDataMapper";
import { getTrackingUserId } from "./HelloRetailHelper";

const HelloRetail = {
	trackingUserForGuests: (self) => {
		try {
			if (self.$store.getters.featureToggles.enableHelloRetail) {
				const trackingUserId = getTrackingUserId(self.$store.getters);
				if (!trackingUserId) {
					HelloRetailClient.trackingUser(self).then(res => {
						if (res.data.success === true) {
							localStorage.setItem("helloRetail_trackingUserId_guest", res.data.id);
						}
					});
				}
			}
		} catch(e) {
			LoggerProvider.logEvent({
				message: JSON.stringify(e),
				eventName: `${self.$route.name}`,
				eventCategory: "HelloRetail"
			});
		}
	},
	pageView: (self, {productId} = {}) => {
		try {
			if (self.$store.getters.featureToggles.enableHelloRetail) {
				const data = HelloRetailDataMapper.forPageView(self, {productId});
				HelloRetailClient.pageView(self, data);
			}
		} catch(e) {
			LoggerProvider.logEvent({
				message: JSON.stringify(e),
				eventName: `${self.$route.name}`,
				eventCategory: "HelloRetail"
			});
		}
	},
	clickTracking: (self, source) => {
		try {
			if (self.$store.getters.featureToggles.enableHelloRetail) {
				HelloRetailClient.clickTracking(self, source);
			}
		} catch(e) {
			LoggerProvider.logEvent({
				message: JSON.stringify(e),
				eventName: `${self.$route.name}`,
				eventCategory: "HelloRetail"
			});
		}
	},
	cartTracking: (self) => {
		try {	
			if (self.$store.getters.featureToggles.enableHelloRetail) {
				const data = HelloRetailDataMapper.forCartTracking(self);
				HelloRetailClient.cartTracking(self, data);
			}
		} catch(e) {
			LoggerProvider.logEvent({
				message: JSON.stringify(e),
				eventName: `${self.$route.name}`,
				eventCategory: "HelloRetail"
			});
		}
	},
	conversionTracking: (self, {order} = {}) => {
		try {
			if (self.$store.getters.featureToggles.enableHelloRetail) {
				const data = HelloRetailDataMapper.forConversionTracking(self, {order});
				HelloRetailClient.conversionTracking(self, data);
			}
		} catch(e) {
			LoggerProvider.logEvent({
				message: JSON.stringify(e),
				eventName: `${self.$route.name}`,
				eventCategory: "HelloRetail"
			});
		}
	}
};

export default HelloRetail;